import React from 'react';

import SuccessRedirector from 'components/SuccessRedirector';

export default function ChangeEmailSuccess() {
  return <SuccessRedirector description="Your email address has been successfully updated." />;
}
